$(document).ready(() => {
    $('.header-navigation .list-menu .has-megamenu').on('click', (event) => {
        if ($(event.target).hasClass('site-nav-title')) return;
        
        event.preventDefault();
        event.stopPropagation();

        // Remove a classe 'open-megamenu' de todos os outros elementos
        if (!$(event.currentTarget).hasClass('open-megamenu')) {
            $('.header-navigation .list-menu .has-megamenu').removeClass('open-megamenu');
        }

        // Alterna a classe 'open-megamenu' no item atual
        $(event.currentTarget).toggleClass('open-megamenu');

        // Adiciona ou remove a classe 'open-megamenu' no body conforme o estado do item atual
        if ($(event.currentTarget).hasClass('open-megamenu')) {
            $('body').addClass('open-megamenu');
        } else {
            $('body').removeClass('open-megamenu');
        }
    });

    // Fecha o megamenu ao clicar fora dele
    $(document).on('click', (event) => {
        if (!$(event.target).closest('.header-navigation .list-menu .has-megamenu').length) {
            $('.header-navigation .list-menu .has-megamenu').removeClass('open-megamenu');
            $('body').removeClass('open-megamenu');
        }
    });

    // Fecha o megamenu ao scrollar a página
    $(window).on('scroll', () => {
        $('.header-navigation .list-menu .has-megamenu').removeClass('open-megamenu');
        $('body').removeClass('open-megamenu');
    });

  
    $('.productView-image-wrapper .zoom-switch').on('click', () => {
        $('.productView-image-wrapper').toggleClass('zooming');
    })
});
